<template>
  <div class="tw-flex tw-justify-center tw-items-center">
    <base-select
      straight-left
      :model-value="activeSort"
      :options="selectSortOptions"
      :input-loading="inputLoading"
      @input="handleSelect"
    >
      <template #prepend>
        <font-awesome-icon class="tw-ml-4 tw--mr-1" icon="sort-amount-down" />
      </template>
    </base-select>
  </div>
</template>

<script>
import { computed, toRefs } from 'vue'
import { useSort } from '@composables'
import { useI18n } from 'vue-i18n'

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    sortOptions: {
      type: Array,
      required: true,
    },
    inputLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:sort'],
  setup(props, { emit }) {
    const { sortOptions, id } = toRefs(props)
    const { sort } = useSort(id.value)
    const { t } = useI18n()

    const selectSortOptions = computed(() =>
      sortOptions.value.map((f) => ({
        value: f.key,
        text: t(f.name),
      }))
    )

    const activeSort = computed(() => sort.value?.sortBy)

    function handleSelect(input) {
      if (input === activeSort.value) return
      const selected = sortOptions.value.find((s) => s.key === input)
      if (selected) emit('update:sort', selected)
    }

    return {
      selectSortOptions,
      handleSelect,
      activeSort,
    }
  },
}
</script>
